var _filter, _radialGradient, _linearGradient, _linearGradient2, _linearGradient3, _mask, _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _g, _circle, _g2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductsImage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 480,
    viewBox: "0 0 500 480",
    width: 500,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 72.8823,
    width: 72.8823,
    x: 344.368,
    y: 140.412
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_62:128",
    stdDeviation: 10.5
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(0 40.2574 -40.2574 0 377.5 194.5)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 358.554,
    x2: 242.956,
    xlinkHref: "#c",
    y1: 226.723,
    y2: 282.349
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 343.992,
    x2: 340.23,
    xlinkHref: "#c",
    y1: 228.548,
    y2: 234.571
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "f",
    height: 75,
    maskUnits: "userSpaceOnUse",
    width: 75,
    x: 340,
    y: 157
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 377.5,
    cy: 194.5,
    fill: "#4a6cf7",
    opacity: 0.8,
    r: 37.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#151a3e",
    height: 480,
    rx: 2,
    width: 500
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#474c72",
    height: 156,
    rx: 2,
    width: 225,
    x: 35,
    y: 117
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m35 80.5h430",
    opacity: 0.1,
    stroke: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#2c3151",
    height: 156,
    rx: 2,
    width: 175,
    x: 290,
    y: 117
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#4a6cf7",
    height: 142,
    opacity: 0.3,
    rx: 2,
    width: 430,
    x: 35,
    y: 303
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 8,
    opacity: 0.5,
    rx: 2,
    width: 229,
    x: 194,
    y: 353
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 8,
    opacity: 0.5,
    rx: 2,
    width: 152,
    x: 194,
    y: 370
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 8,
    opacity: 0.5,
    rx: 2,
    width: 187,
    x: 194,
    y: 387
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    fill: "#4a6cf7",
    fillOpacity: 0.73,
    height: 100,
    rx: 2,
    width: 100,
    x: 59,
    y: 324
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 18,
    opacity: 0.1,
    rx: 2,
    width: 327,
    x: 138,
    y: 35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.2391,
    cy: 44.2391,
    opacity: 0.3,
    r: 4.23913
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 44.2391,
    opacity: 0.3,
    r: 4.23913
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7609,
    cy: 44.2391,
    opacity: 0.3,
    r: 4.23913
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 377.5,
    cy: 194.5,
    fill: "#4a6cf7",
    opacity: 0.8,
    r: 37.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 377.5,
    cy: 194.5,
    fill: "url(#b)",
    opacity: 0.8,
    r: 37.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 380.809,
    cy: 176.853,
    fill: "#fff",
    r: 15.4412
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m342.034 231.847c-17.07 30.902-64.095 81.339-115.64 35.871",
    stroke: "url(#d)",
    strokeDasharray: "2 2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m339.077 230.867 4.896-1.896.589 4.685",
    stroke: "url(#e)",
    strokeDasharray: "2 2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsImage2);
export default __webpack_public_path__ + "static/media/products-image-2.f21999e3e7f197ee01d1da306cb3675b.svg";
export { ForwardRef as ReactComponent };